import { axios, Response } from '..'

export type Persona = {
  userId: string
  username: string
  avatarUrl: string
}

const getPersonasById = (personaId: string): Response<Persona[]> => {
  return axios.get(`/v1/personas/${personaId}`)
}

export default getPersonasById
